

export function GalleryCPT_CORNER(){
  return {
    "images": [
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_001.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_002.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_003.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_004.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_005.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_006.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_007.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_008.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_009.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_010.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_011.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_012.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_013.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_014.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_015.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_016.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_017.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_018.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_019.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_020.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_021.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_022.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_023.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_024.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_025.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_026.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_027.jpg"},
        {"original": "https://jamhaw.com/images/gallery/GalleryCPT_CORNER/IMG_028.jpg"}
    ]
  }
}
